import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HomeService } from '../home-service/home.service';
import { EmpresaBuscaService } from 'src/app/empresas/services/empresa-busca.service';

@Component({
  selector: 'app-bloco-status-rede',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './bloco-status-rede.component.html',
  styleUrls: ['./bloco-status-rede.component.scss'],
})
export class BlocoStatusRedeComponent implements OnInit {
  loading = true;
  atualizacoesRelevantes: any[] = [];
  obrasSemInteracao = 0;
  tarefasAtrasadas = 0;
  novasObrasVinculadas = 0;

  private readonly homeService = inject(HomeService);
  private readonly empresaBuscaService = inject(EmpresaBuscaService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    forkJoin({
      status: this.homeService.getNetworkStatus(7, 10).pipe(catchError(() => of(null))),
      carteira: this.empresaBuscaService.portfolioOverview(false, 0).pipe(catchError(() => of(null))),
    }).subscribe({
      next: ({ status, carteira }) => {
        const d = status?.data;

        this.atualizacoesRelevantes = (d?.atualizacoesRelevantes ?? []).map((item: any) => ({
          total: item.totalNovasObras,
          descricao: item.moduleName,
        }));
        this.obrasSemInteracao = d?.pontosDeAtencao?.obrasSemInteracao ?? 0;
        this.tarefasAtrasadas = d?.pontosDeAtencao?.tarefasAtrasadas ?? 0;
        this.novasObrasVinculadas = carteira?.data?.newWorks ?? 0;

        this.loading = false;
      },
      error: () => { this.loading = false; },
    });
  }

  irParaCarteiraEmpresas(): void {
    this.router.navigate(['/empresas/minha-carteira']);
  }
}